import { makeStyles } from '@mui/styles';

export const useStyles = (drawerOpenWidth, drawerClosedWidth) => {
  const styles = makeStyles(() => ({
    hide: {
      visibility: 'hidden',
    },
    none: {
      display: 'none',
    },
    drawer: {
      width: drawerOpenWidth,
      flexShrink: 0,
    },
    drawerOpen: {
      width: drawerOpenWidth,
    },
    drawerClose: {
      overflowX: 'hidden',
      width: drawerClosedWidth,
    },
  }));

  return styles();
};
